/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ImportAuditRow = {
    /**
     * Primary key.
     */
    id: number;
    /**
     * Name of the imported file.
     */
    filename: string;
    /**
     * Type of the imported file.
     */
    fileType?: ('RABTAB' | 'WTAB' | null);
    /**
     * Current status of the import job.
     */
    status: ImportAuditRow.status;
    /**
     * Timestamp when the import job started.
     */
    startedAt?: string | null;
    /**
     * Timestamp when the import job finished.
     */
    finishedAt?: string | null;
    /**
     * Number of records processed.
     */
    recordsProcessed?: number | null;
    /**
     * Number of records rejected.
     */
    recordsRejected?: number | null;
    /**
     * Error message if the import failed.
     */
    error?: string | null;
};
export namespace ImportAuditRow {
    /**
     * Current status of the import job.
     */
    export enum status {
        RUNNING = 'running',
        SUCCESS = 'success',
        ERROR = 'error',
        CANCELLED = 'cancelled',
    }
}

